import React, { useState } from "react";
import SocialMedia from "../components/SocialMedia";
import { Link } from "react-router-dom";
const projects = require("../assets/projects.json");

const chechVideoLink = (videoLink) => {
  if (videoLink === "") {
    alert("No Demo");
  }
};

const Projects = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [projectDescription, setProjectDescription] = useState("");
  const [selectedProject, setSelectedProject] = useState(null);

  // Function to open the dialog and set the project description
  const openDialog = (description) => {
    setShowDialog(true);
    setProjectDescription(description);
  };

  // Function to close the dialog
  const closeDialog = () => {
    setShowDialog(false);
    setProjectDescription("");
    setSelectedProject(null);
  };

  return (
    <>
      <section className="flex flex-col w-full h-full p-4 bg-gradient-to-r from-teal-900 to-stone-800">
        {/* Social Media */}
        <SocialMedia title="Projects" />
        <div className="flex flex-wrap w-min-full justify-center border-t border-gray-300 pt-2">
          {/* Project Card */}
          {projects.map((project) => (
            <div className="card" key={project.id}>
              <div className="flex flex-col justify-between mb-1">
                <h2 className="text-white border-b m-1">{project.title}</h2>

                <div className="flex flex-row">
                  <Link to={project.github_link} className="std-button mr-1">
                    Visit
                  </Link>
                  <Link
                    to={project.video_link}
                    className="std-button mr-1"
                    onClick={() => chechVideoLink(project.video_link)}
                  >
                    Demo
                  </Link>
                  <Link
                    to=""
                    className="std-button"
                    onClick={() => {
                      setSelectedProject(project);
                      openDialog(project.description);
                    }}
                  >
                    Description
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* The modal dialog */}
      {showDialog && selectedProject && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-btn" onClick={closeDialog}>
              &times;
            </span>
            <h2 className="border-b m-1">{selectedProject.title} Description</h2>
            <p>{projectDescription}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Projects;
